/**
 * 导出参数相关常量
 */

// 文件名模板
export const FILE_NAME_TEMPLATE = 'clarity-params-{timestamp}.json'

// 时间戳格式化模式
export const TIMESTAMP_PATTERN = /:/g

// 时间戳替换字符
export const TIMESTAMP_REPLACEMENT = '-'

// MIME 类型
export const JSON_MIME_TYPE = 'application/json'

// 文件扩展名
export const JSON_FILE_EXTENSION = '.json'